import type {CopilotMarkdownExtension} from '@github-ui/copilot-markdown/extension'

import {type NodeMeta, YamlBlockExtension} from '../../yaml-block-extension'
import {ListBlock, type ListBlockProps} from './IssueListBlock'

const instance = new (class extends YamlBlockExtension<ListBlockProps> {
  override get dataAttribute(): `data-${string}` {
    return 'data-issues-list-block'
  }

  override isSupported(node: NodeMeta): boolean {
    return node.lang === 'list' && (node.type === 'issue' || node.type === 'pr' || node.type === 'task')
  }

  override extractProps(node: NodeMeta): ListBlockProps {
    return {
      data: node.value,
      type: node.type as 'issue' | 'pr' | 'task',
      isStreaming: node.isStreaming ?? false,
      id: node.id,
    }
  }

  override createComponent(props: ListBlockProps): React.ReactNode {
    return <ListBlock {...props} />
  }
})()

export default function listExtension(): CopilotMarkdownExtension {
  return instance
}
